import Register from './Register.container';

export default Register;
